const keycloakUrl = 'admin/realms/Sistema-de-Padrones/';
export { keycloakUrl };
